module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "centre"
  }, [_c('img', {
    attrs: {
      "alt": "cover",
      "height": "98%",
      "src": "images/title.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.5em"
    }
  }, [_c('span', {
    staticClass: "Baskerville-Italic",
    staticStyle: {
      "font-size": "140%"
    }
  }, [_vm._v("No halos, no wings.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Dedicated to all those everywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("who spread kindness ")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("every day.")]), _c('span', {
    staticClass: "char-style-override-10"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfb4d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 63
// module chunks = 0